module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wc-input-wrapper control-label",
    class: {
      'has-error': _vm.invalid, 'has-success': _vm.isDirty, 'has-awesome': _vm.isAwesome
    }
  }, [(_vm.label) ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    class: {
      'i-am-sunny': _vm.disabled
    },
    attrs: {
      "rows": _vm.rows,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.update,
      "blur": _vm.touch
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f1e6f82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/forms/wc-textarea.vue
// module id = 815
// module chunks = 3